// src/store/useStoreAllCats.ts
import { create } from "zustand";
import axios from "axios";
import { URL } from "../../lib/apis";

interface VehicleState {
  AllCats: any[]; // L'état pour stocker les données de véhicules
  loadingAllCats: boolean; // Nouveau state pour suivre l'état du chargement
  fetchAllCats: () => Promise<void>; // Fonction pour récupérer les véhicules
}

const useStoreAllCats = create<VehicleState>((set) => ({
  AllCats: [],
  loadingAllCats: false,
  fetchAllCats: async () => {
 /*    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("User is not authenticated");
    }

    if (!token) {
      console.error("No token available. User might not be authenticated.");
      return;
    } */
    set({ loadingAllCats: true }); // Démarre le chargement
    try {
      const response = await axios.get(
        `${URL}/categories/subcategories`,
     /*    {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in headers
          },
        } */
      );
      set({ AllCats: response.data.data, loadingAllCats: false }); // Met à jour les données et arrête le chargement
    } catch (error) {
      console.error("Error fetching AllCats:", error);
      set({ loadingAllCats: false }); // Arrête le chargement en cas d'erreur
    }
  },
}));

export default useStoreAllCats;
